/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'label': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M17.63 5.84C17.27 5.33 16.67 5 16 5H5a2 2 0 00-2 2v10a2 2 0 002 2h11c.67 0 1.27-.34 1.63-.85L22 12l-4.37-6.16z"/>'
  }
})
